import 'leo-styles/theme.less';
import 'leo-styles/index.scss';
import React, { useEffect, useState } from 'react';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import { store, Provider, useDispatch, useSelector } from 'leo-store';
import Loading from 'leo-components/Loading';
import AppMenu from './layout/menu';
import Router from './router';


const App = () => {
  const dispatch = useDispatch();
  const state = useSelector((state) => state.main);
  const [menuCollapsed, setMenuCollapsed] = useState(true);

  useEffect(() => {
    dispatch.main.getUserInfo();
  }, []);

  useEffect(() => {
    // 登录即获取公司列表
    if (state.hasLogin) {
      dispatch.common.getInspectionCompany();
    }
  }, [state.hasLogin]);

  if (state.loading) {
    return <Loading />;
  }

  return (
    <React.Fragment>
      {state.hasLogin && (
        <AppMenu
          state={state}
          collapsed={menuCollapsed}
          onCollapsedChange={setMenuCollapsed}
        />
      )}
      <div
        className="main-content"
        style={{
          marginLeft: state.hasLogin ? (menuCollapsed ? 80 : 240) : 0,
          transition: 'margin-left 0.3s cubic-bezier(0.2, 0, 0, 1)',
          transform: 'translateZ(0)',
          minHeight: '100vh',
          height: '100%',
        }}
      >
        <Router
          hasLogin={state.hasLogin}
          menuList={state.menuList}
          authorities={state.authorities}
        />
      </div>
    </React.Fragment>
  );
};

const AppProvider = () => {
  return (
    <div className="sub-system top-container leo-root">
      <Provider store={store}>
        <ConfigProvider locale={zhCN}>
          <App />
        </ConfigProvider>
      </Provider>
    </div>
  );
};
export default AppProvider;
